import React from 'react';
import ThePlatform from '../components/ThePlatform';
import WinterJumbo from '../components/WinterJumbo';

const Platform = () => (
  <div>

    <WinterJumbo 
      title="The Platform"
    />

    <ThePlatform />

  </div>
);

export default Platform;



// WEBPACK FOOTER //
// ./src/pages/platform.js